/**============================================================
*   [Class] TOP：事例スライダー
============================================================*/
export default class TopCaseSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);
    this.swiperSlideItem = document.querySelectorAll(`.p-top-case__slider--pc .swiper-slide`);
    // 各 .swiper-slide を複製して末尾に挿入
    this.swiperSlideItem.forEach(slide => {
      const clonedSlide = slide.cloneNode(true);
      document.querySelector(`.p-top-case__slider--pc .swiper-wrapper`).appendChild(clonedSlide);
    });


    //thumb slide
    this.swiperThumbSlide = document.querySelector(`.p-top-case__slider--sp`);
    this.swiperThumbSlideItem = document.querySelectorAll(`.p-top-case__slider--sp .swiper-slide`);

    // 各 .swiper-slide を複製して末尾に挿入※サムネイルスライドが3枚以上ないと動かない
    this.swiperThumbSlideItem.forEach(slide => {
      const clonedSlide = slide.cloneNode(true);
      document.querySelector(`.p-top-case__slider--sp .swiper-wrapper`).appendChild(clonedSlide);
    });

    //サムネイルスライド
    const swiperThumbnail = new Swiper(this.swiperThumbSlide, {
      loop: true,
      slidesPerView: 1,
      freeMode: true,
      watchSlidesProgress: true,//スライダーの動きにスライドを追従させる
      loopAdditionalSlides: 1,
      loopPreventsSlide: true,
      loopedSlides: 0,
      speed: 2000,
      followFinger: false,
      grabCursor: false,
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
    });

    //メインスライド
    new Swiper(this.swiperSlide, {
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 1,
      loopPreventsSlide: true,
      loopedSlides: 0,
      followFinger: false,
      speed: 2000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
      grabCursor: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      thumbs: {
        swiper: swiperThumbnail, //連動したいスライダー（swiperThumbnailを指定する）
      },
    });
  }
}
